import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchBoardList = async (params) => {
  const response = await get("/boardList", { params });
  return response;
};

export function useBoardList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);

  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      createStDate: "",
      createEndDate: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });

  const { watch, setValue } = methods;
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const createStDate = searchParams.get("createStDate") || "";
  const createEndDate = searchParams.get("createEndDate") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;
  const sortField = searchParams.get("sortField") || "";
  const sortOrder = searchParams.get("sortOrder") || "";

  const queryParam = {
    searchCnd,
    searchWrd,
    createStDate,
    createEndDate,
    pageIndex,
    recordCountPerPage,
    sortField,
    sortOrder,
  };

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["selectBoardList", queryParam],
    queryFn: () => fetchBoardList(queryParam),
    // enabled: false, // 더미 데이터 사용중 false
    keepPreviousData: true,
    staleTime: 600000,
  });

  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("createStDate", values.createStDate ? values.createStDate + " 00:00:00" : "");
    newParams.set("createEndDate", values.createEndDate ? values.createEndDate + " 23:59:59" : "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const handleSelectAll = (e) => {
    if (!data || !data.resultList) return;
    const { checked } = e.target;
    if (checked) {
      const allIds = data.resultList.map((item) => item.boardNum);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (boardNum) => {
    if (selectedItems.includes(boardNum)) {
      setSelectedItems(selectedItems.filter((id) => id !== boardNum));
    } else {
      setSelectedItems([...selectedItems, boardNum]);
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
      alert("삭제할 항목을 선택해주세요.");
    } else {
      alert(`선택된 항목들: ${selectedItems.join(", ")} 삭제 로직 실행(예시)`);
    }
  };

  // 체크 여부
  const isAllChecked = !!(data?.resultList && data.resultList.length > 0 && selectedItems.length === data.resultList.length);

  return {
    methods,
    data,
    isLoading,
    isError,
    error,
    watch,
    setValue,
    selectedItems,
    isAllChecked,
    onSubmit,
    handlePageChange,
    handleSelectAll,
    handleSelectItem,
    handleDelete,
    pageIndex,
    recordCountPerPage,
    refetch,
    refreshList,
  };
}
